import { PlusIcon } from "../icons";

const changes = [
  { title: "orders.customer_email → customer_contact", status: "Owner interview ready", risk: "High", tone: "high", selected: true },
  { title: "billing.amount → total_amount", status: "Impact scan complete", risk: "Medium", tone: "medium", selected: false },
  { title: "dim_date.calendar_day → day", status: "Drafting questions", risk: "Low", tone: "low", selected: false },
] as const;

export function ChangeQueue() {
  return (
    <aside className="change-queue">
      <h2>Change queue</h2>
      <div className="queue-list" role="list">
        {changes.map((change) => (
          <button className={`queue-row${change.selected ? " is-selected" : ""}`} type="button" key={change.title} role="listitem">
            <strong>{change.title}</strong>
            <span>{change.status}</span>
            <small className={`risk risk-${change.tone}`}><i />{change.risk}</small>
          </button>
        ))}
      </div>
      <button className="new-change" type="button"><PlusIcon /> New change</button>
    </aside>
  );
}
